import {
  BanknoteIcon,
  BriefcaseBusinessIcon,
  BuildingIcon,
  CalendarPlusIcon,
  ClockIcon,
  FilePlusIcon,
  FileTextIcon,
  FlagIcon,
  ListTodoIcon,
  TicketIcon,
  UserPlusIcon,
  UsersIcon,
  type LucideIcon,
} from "lucide-react";

const ICONS: Record<string, LucideIcon> = {
  ticket: TicketIcon,
  task: ListTodoIcon,
  project: BriefcaseBusinessIcon,
  milestone: FlagIcon,
  daily_activity: ClockIcon,
  holiday_request: CalendarPlusIcon,
  lead: UserPlusIcon,
  contact: UsersIcon,
  client: BuildingIcon,
  invoice: FileTextIcon,
  payment: BanknoteIcon,
};

/** Icon for an entity in menus; generic file icon when unknown. */
export function entityIcon(name: string): LucideIcon {
  return ICONS[name] ?? FilePlusIcon;
}
